/* tslint:disable */

declare var Object: any;
export interface UICacheInterface {
  "id"?: number;
}

export class UICache implements UICacheInterface {
  "id": number;
  constructor(data?: UICacheInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UICache`.
   */
  public static getModelName() {
    return "UICache";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UICache for dynamic purposes.
  **/
  public static factory(data: UICacheInterface): UICache{
    return new UICache(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UICache',
      plural: 'UICache',
      path: 'UICache',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
